import React, {useState, useEffect} from "react"

import Button from "@irati/ui/src/Button"
import Form from "@irati/ui/src/Form"
import mfaService from "@irati/auth/services/mfa"
import {MFACode} from "@irati-web/fields/mfa"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import {mfaTracking} from "@irati-tracking/platform"
import {Label} from "@irati/ui/src/Typography"
import ErrorText from "@irati/ui/src/ErrorText"
import Spacing from "@irati/ui/src/Spacing"
import {getErrorMessage} from "@irati/utils/lang/formatError"

import {MFA_TYPE} from "@irati-tracking/platform/mfa"
import {Modal} from "../../BaseModal"
import {ExtraData, SelectScreen} from "../index"
import {ButtonContainer} from "../styled"

interface Props extends InjectIntl {
  selectScreen: SelectScreen
  onCancel(): void
  show: boolean
  extraData?: ExtraData
}

const MFAPopupEnterCode: React.FC<Props> = (props) => {
  const [code, setCode] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [submit, setSubmit] = useState<Promise<any>>(Promise.resolve())
  const [error, setError] = useState("")

  useEffect(() => {
    if (props.show && !props.extraData?.smsAlreadyRequested) {
      mfaService.request().then((mfa) => {
        setPhoneNumber(mfa.phoneNumberLastDigits!)
        mfaTracking.popupRequestCode({type: MFA_TYPE.SMS})
      })
    }
  }, [props.show])

  const handleSuccess = (e?: any) => {
    if (e && e.preventDefault) e.preventDefault()
    setSubmit(
      mfaService
        .validate(code)
        .then(() => {
          props.selectScreen(null)
          mfaTracking.popupComplete({type: MFA_TYPE.SMS})
        })
        .catch((err: PBError) => {
          setError(getErrorMessage(err))
        })
    )
  }

  const handleChange = (c: string) => {
    setCode(c)
    setError("")
  }

  const handleCancel = () => {
    props.onCancel()
    mfaTracking.popupCancel({type: MFA_TYPE.SMS})
  }

  const {formatMessage, show} = props

  return (
    <Modal show={show} header="platform.mfa.enterCode.title">
      <Form onSubmit={handleSuccess}>
        <MFACode label={formatMessage({id: "platform.mfa.mfaCode.label"}, {phoneNumber})} value={code} onChange={handleChange} />
        {error && (
          <Spacing marginBottom={2}>
            <ErrorText>
              <FormattedMessage id={error} />
            </ErrorText>
          </Spacing>
        )}
        <Label>
          <FormattedMessage id="platform.mfa.mfaCode.hint" />
        </Label>
      </Form>
      <ButtonContainer>
        <Button tertiary onClick={handleCancel} marginRight={2}>
          <FormattedMessage id="platform.mfa.enterCode.cancel" />
        </Button>
        <Button onClick={handleSuccess} primary load={submit}>
          <FormattedMessage id="platform.mfa.enterCode.submit" />
        </Button>
      </ButtonContainer>
    </Modal>
  )
}

export default injectIntl(MFAPopupEnterCode)
